import React from 'react';
import { BellDot, MessageCircle, Sparkles, Wallet } from 'lucide-react';
import { DashboardCard } from './DashboardShared';

interface DashboardHeroProps {
  userName: string;
  email?: string;
  walletBalance: number;
  unreadMessages: number;
}

export const DashboardHero: React.FC<DashboardHeroProps> = ({ userName, email, walletBalance, unreadMessages }) => {
  const initial = (userName || 'ک').trim().charAt(0);
  return (
    <DashboardCard className="overflow-hidden border-[#DDE5FF] bg-[linear-gradient(140deg,#FFFFFF_0%,#F3F7FF_100%)] p-0 text-slate-800 shadow-[0_22px_44px_-26px_rgba(28,59,155,0.35)]">
      <div className="relative">
        <div className="pointer-events-none absolute -left-16 -top-20 h-44 w-44 rounded-full bg-blue-200/35 blur-2xl" />
        <div className="pointer-events-none absolute -right-16 -bottom-20 h-44 w-44 rounded-full bg-indigo-200/30 blur-2xl" />
        <div className="relative p-4 sm:p-6">
          <div className="flex flex-col gap-5 sm:flex-row sm:items-start sm:justify-between">
            <div className="flex items-start gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#1C3B9B] text-lg font-black text-white shadow-[0_14px_24px_-14px_rgba(28,59,155,0.65)]">
                {initial}
              </div>
              <div>
                <div className="inline-flex items-center gap-1.5 rounded-full border border-[#C8D6FF] bg-white px-2.5 py-1 text-[11px] font-extrabold text-[#1C3B9B]">
                  <Sparkles className="h-3.5 w-3.5" />
                  <span>داشبورد مشتری</span>
                </div>
                <h1 className="mt-2 text-2xl font-black text-slate-900 sm:text-3xl">سلام {userName}</h1>
                {email ? <p className="mt-1.5 text-sm text-slate-600">{email}</p> : null}
              </div>
            </div>
            <div className="hidden items-center gap-2 rounded-xl border border-[#DDE5FF] bg-white px-3 py-2 text-xs font-bold text-slate-600 sm:inline-flex">
              <BellDot className="h-4 w-4 text-[#1C3B9B]" />
              نمای کلی حساب شما به‌روز است
            </div>
          </div>

          <div className="mt-5 grid gap-3 sm:grid-cols-2">
            <div className="rounded-2xl border border-[#DDE5FF] bg-white p-3.5 shadow-[0_10px_20px_-16px_rgba(15,23,42,0.4)]">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 text-[#1C3B9B]">
                  <Wallet className="h-4 w-4" />
                  <span className="text-xs font-semibold">موجودی کیف پول</span>
                </div>
                <span className="rounded-full bg-[#EEF4FF] px-2 py-0.5 text-[10px] font-black text-[#1C3B9B]">قابل استفاده</span>
              </div>
              <p className="mt-2.5 text-lg font-black text-slate-900 sm:text-xl">{walletBalance.toLocaleString('fa-IR')} تومان</p>
            </div>
            <div className="rounded-2xl border border-[#DDE5FF] bg-white p-3.5 shadow-[0_10px_20px_-16px_rgba(15,23,42,0.4)]">
              <div className="flex items-center justify-between gap-2">
                <div className="flex items-center gap-2 text-[#1C3B9B]">
                  <MessageCircle className="h-4 w-4" />
                  <span className="text-xs font-semibold">پیام خوانده‌نشده</span>
                </div>
                <span className="rounded-full bg-[#EEF4FF] px-2 py-0.5 text-[10px] font-black text-[#1C3B9B]">صندوق ورودی</span>
              </div>
              <p className="mt-2.5 text-lg font-black text-slate-900 sm:text-xl">{unreadMessages.toLocaleString('fa-IR')}</p>
            </div>
          </div>
        </div>
      </div>
    </DashboardCard>
  );
};
